// @ts-nocheck

import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketRequestSwitchMode } from '../../actions/basket';
import useMergeProps from '../../hooks/useMergeProps';

import BasketTabs from './BasketTabs';
import selectBasketTabsProps from './BasketTabs.selector';

type PropsType = {
  className?: string;
};

const BasketTabsContainer = (ownProps: PropsType) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(selectBasketTabsProps);

  const actionsProps = useMemo(
    () => ({
      onSelectionChange: (mode) => dispatch(basketRequestSwitchMode({ mode })),
    }),
    [dispatch],
  );

  const enhancedProps = useMergeProps({ selectedProps, actionsProps, ownProps });

  return <BasketTabs {...enhancedProps} />;
};

export default BasketTabsContainer;
